import { StyleSheet } from 'react-native';
import * as Colors from './Colors';
import * as Constants from './Constants';

export const styleSheet = StyleSheet.create({
  headerTextStyle: {
    fontSize: Constants.LARGE_FONT,
    color: Colors.Black,
    fontWeight: 'bold',
  },

  subTextStyle: {
    color: Colors.Black,
    fontSize: Constants.NORMAL_FONT,
  },
  smallText: {
    color: Colors.Black,
    fontSize: 12.0,
  },

  boldText: {
    fontSize: 20.0,
    color: Colors.Black,
    fontWeight: 'bold',
  }
});
